export default "__VITE_ASSET__CqmWsgmM__"